import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import employeeService from '../../../services/Employee.service';
import StencilLinkStyling from '../common/StencilLinkStyling';

import { Flyout, FlyoutContent } from '@amzn/stencil-react-components/flyout';
import { Text } from '@amzn/stencil-react-components/text';

class AnnualReportProxyStatementDialog extends Component {
  render() {
    const { t, employee } = this.props;
    const dialogText =
      employeeService.isWholeFoodsEmployee(employee) || employeeService.isZooxEmployee(employee)
        ? t('AnnualReportProxyStatementDialog.TextWholeFoods')
        : t('AnnualReportProxyStatementDialog.Text');

    return (
      <Flyout isOpen={this.props.visible} close={this.props.onCloseDialog}>
        <FlyoutContent
          titleText={t('PopularActions.WantToSeeButton')}
          closeButtonAltText="Close Button For Proxy Statement Dialog"
          onCloseButtonClick={this.props.onCloseDialog}
        >
          <StencilLinkStyling>
            <Text fontSize="T400" dangerouslySetInnerHTML={{ __html: dialogText }} />
          </StencilLinkStyling>
        </FlyoutContent>
      </Flyout>
    );
  }
}

const mapState = (state) => ({
  employee: state.employee,
});

export default connect(mapState)(withTranslation('translationsV2')(AnnualReportProxyStatementDialog));
